"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTrendsState = void 0;
var TrendsTranslate_init_1 = require("@/pages/common/states/TrendsTranslate.init");
var TrendsChartGroupNewState_init_1 = require("./TrendsChartGroupNewState.init");
exports.defaultTrendsState = {
    newChartGroups: TrendsChartGroupNewState_init_1.defaultTrendsChartGroupNewState,
    t: TrendsTranslate_init_1.defaultTrendsTranslate,
    chartPopup: null,
    customFrom: "2006-01-01",
    customTo: "2023-12-31",
};
